import React, { Component, Fragment } from 'react'
import { Link }             from "react-router-dom"
import { withRouter }       from "react-router"
import { Table } from 'elemental-react16'
import { Button, Icon, Modal, Progress,  StepTitle,
    StepGroup,
    StepDescription,
    StepContent,
    Step, } from "semantic-ui-react";
import Responsive from "react-responsive"

@withRouter
class ReturnPageProgress extends Component {

    render() {
        const {referer, isRequest, activeStep = 0, progress} = this.props
        return (
        <Fragment>
        <Responsive minWidth={790} >
            <div className="tc">
            <StepGroup ordered style={{borderRadius: "25px"}}>
                <Step completed={progress >= 1} active={progress < 1} style={{borderRadius: "25px"}}>
                <StepContent>
                <StepTitle>Information</StepTitle>
                <StepDescription>Markt- und Vorjahresinformationen</StepDescription>
                </StepContent>
                </Step>
                <Step completed={progress >= 2} active={progress === 1} style={{borderRadius: "25px"}}>
                <StepContent>
                <StepTitle>Bausteinerfassung</StepTitle>
                <StepDescription>Erfassung der Bausteine</StepDescription>
                </StepContent>
                </Step>
                <Step completed={progress >= 3} active={progress === 2} style={{borderRadius: "25px"}}>
                <StepContent>
                <StepTitle>Lieferhinweise</StepTitle>
                <StepDescription>Geben Sie Ihre Lieferhinweise ein</StepDescription>
                </StepContent>
                </Step>
                <Step completed={progress >= 4} active={progress === 3} style={{borderRadius: "25px"}}>
                <StepContent>
                <StepTitle>Bestätigung</StepTitle>
                <StepDescription>Überprüfung Ihrer Daten</StepDescription>
                </StepContent>
                </Step>
            </StepGroup>
         </div>
        </Responsive>

        <Responsive maxWidth={789} >
        <div>
            <div className="ui top attached steps">
            {progress == 0 && <div className={progress >= 1 ? "completed step" : (progress === 0 ? "active step" : "step")}><i aria-hidden="true" className="id badge icon"></i>
            <div className="content">
                <div className="title">Information 1 / 4</div>
                <div className="description">Markt- und Vorjahresinformationen</div>
                </div>
            </div>}
            {progress == 1 && <div className={progress >= 2 ? "completed step" : (progress === 1 ? "active step" : "step")}><i aria-hidden="true" className="truck icon"></i>
                <div className="content">
                <div className="title">Bausteinerfassung 2 / 4</div>
                <div className="description">Erfassung der Bausteine</div>
                </div>
            </div>}
            {progress == 2 && <div className={progress >= 3 ? "completed step" : (progress === 2 ? "active step" : "step")}><i aria-hidden="true" className="address card icon"></i>
                <div className="content">
                <div className="title">Lieferhinweise 3 / 4</div>
                <div className="description">Geben Sie Ihre Lieferhinweise ein</div>
                </div>
            </div>}
            {progress == 3 && <div className={progress >= 4 ? "completed step" : (progress === 3 ? "active step" : "step")}><i aria-hidden="true" className="info circle icon"></i>
                <div className="content">
                <div className="title">Bestätigung 4 / 4</div>
                <div className="description">Überprüfung Ihrer Daten</div>
                </div>
            </div>}
            </div>
            </div>
        </Responsive>

        </Fragment>
        )
    }
}

export default ReturnPageProgress;


// WEBPACK FOOTER //
// ./src/theme/braunsheitmannShop/pages/returnCheckout/ReturnPageProgress.js